// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRetweetOutlinedSvg from "@fishx/icons-svg/es/asn/PRetweetOutlined";
import FishxIcon from '../components/FishxIcon';

var PRetweetOutlined = function PRetweetOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRetweetOutlinedSvg
  }));
};

PRetweetOutlined.displayName = 'PRetweetOutlined';
export default React.forwardRef(PRetweetOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRetweetOutlined.js
// module id = 3589
// module chunks = 0